import { Col, Row } from 'react-bootstrap';

import { Invoice } from 'apps/shared/scripts/__generated__/graphql.generated';
import { Address, LabelValue } from 'apps/shared/scripts/components';
import {
  formatCountryCode,
  formatItem,
  formatPaymentMethod,
  formatPostalCode,
} from 'apps/shared/scripts/utils';

import { invoiceBodyClassName } from './styles';

type Props = Pick<Invoice, 'currencyCode' | 'customer' | 'item' | 'payment'>;

const InvoiceBody = ({ currencyCode, customer, item, payment }: Props) => {
  return (
    <div className={invoiceBodyClassName}>
      <Row>
        <Col>
          <LabelValue
            label="From"
            value={
              <Address
                name="Paddle.com Inc"
                street="3811 Ditmars Blvd #1071"
                city="Astoria"
                zip="11105-1803"
                state="New York"
                country="United States"
              />
            }
          />
        </Col>
        <Col>
          <LabelValue
            label="To"
            value={
              <Address
                name={customer.email}
                zip={formatPostalCode(customer.address.postalCode)}
                country={formatCountryCode(customer.address.countryCode)}
              />
            }
          />
        </Col>
      </Row>
      <Row>
        <Col>
          <LabelValue label="Item" value={formatItem(item)} />
        </Col>
        <Col>
          <LabelValue label="Method" value={formatPaymentMethod(payment)} />
        </Col>
      </Row>
      <LabelValue label="Currency" value={currencyCode} />
    </div>
  );
};

InvoiceBody.displayName = 'InvoiceBody';

export default InvoiceBody;
